import React, {useState} from "react";
import {Button, Card, CardContent, Grid, Typography} from "@material-ui/core";
import usePackageUpdateModalStyles from "./usePackageUpdateModalStyles";
import Utils from "../../helpers/Utils";

const MAX_VISIBLE_FEATURES = 4;

const PlanItem = ({ plan, setShowCautionAlert, setSelectedPlan }) => {
    const classes = usePackageUpdateModalStyles();
    const [showAll, setShowAll] = useState(false);

    const toggleShowAll = () => {
        setShowAll(prev => !prev);
    };

    const visibleFeatures = showAll ? plan.features : plan.features.slice(0, MAX_VISIBLE_FEATURES);

    return(
        <Grid className={classes.gridItem} item>
            {
                plan.current_plan ?
                    <div className={classes.trapezium}>
                        Your Current Plan
                    </div> :
                    null
            }

            <Card className={`${classes.card} ${plan.current_plan ? ' currentPlan': ''}`}>
                {
                    plan.custom ?
                        <div className={classes.ribbon}>
                            <Typography variant="caption" style={{height: 'unset !important'}}>Only for you</Typography>
                        </div> :
                        null
                }

                <CardContent>
                    <Typography variant={'h6'} gutterBottom style={{height: 'unset !important'}}>
                        {plan.title}
                    </Typography>
                    <Typography className={classes.price} style={{height: 'unset !important'}}>
                        ${Utils.fixDecimal(plan.price)}{' '}
                        {/*{plan.discount && (*/}
                        {/*    <span className={classes.discount}>{plan.discount}</span>*/}
                        {/*)}*/}
                    </Typography>
                    <Typography className={classes.description} style={{height: 'unset !important'}}>
                        {plan.description}
                    </Typography>
                    <div className={classes.features}>
                        {
                            visibleFeatures.map((feature, idx) => (
                                <Typography key={idx} className={classes.feature} style={{height: 'unset !important'}}>
                                    {feature}
                                </Typography>
                            ))
                        }
                    </div>

                    {
                        plan.features.length > MAX_VISIBLE_FEATURES && (
                            <div className={classes.seeMore}>
                        <span className={classes.seeMoreButton} onClick={toggleShowAll}>
                            {showAll ? 'See less' : 'See more'}
                        </span>
                            </div>
                        )
                    }
                </CardContent>

                <Button
                    variant={'contained'}
                    color={'primary'}
                    className={classes.button}
                    fullWidth
                    onClick={() => {
                        setShowCautionAlert(true);
                        setSelectedPlan(plan);
                    }}
                >
                    Select this Plan
                </Button>
            </Card>
        </Grid>
    );
};

export default PlanItem;